import * as generalRequest from "@/utils/generalRequest";

export default async function getAppVersionInfo(onSuccess?: (data?: any) => any, handleError?: (err?: any) => any) {
    try {
        const res = await generalRequest.get(`application-version/info`);
        console.log("🚀 ~ getAppVersionInfo ~ res:", res);
        if (res?.statusCode === 200) {
            onSuccess && onSuccess(res);
            return res;
        }
        return null;
    } catch (err) {
        console.error("🚀 ~ getAppVersionInfo ~ err:", err);
        handleError && handleError(err);
        return null;
    }
}
